import style from "../blog.module.css";
import ExpandableText from "../TextoExpandible";
import React, { Suspense, lazy } from "react";
const InstagramEmbed = lazy(() =>
  import("react-social-media-embed").then((module) => ({
    default: module.InstagramEmbed,
  })),
);

const Semana57: React.FC = () => {
  const Notice1 = `¿Dónde está la maquinaria amarilla? Salimos a buscarla y nos llevamos grandes sorpresas. ¿Qué pasó con las fotos multas en Cali? De 7,5 millones un 2,5 millones de foto multas le pertenecen a Cali.

🌻 Recorrimos el corregimiento de El Hormiguero en compañía de la Asociación Agro Afro Praderas del Rio en una gran Juntanza de #AlianzaPorLaVida. 🧑🏼‍🌾🌾

🇨🇴 Seguimos reafirmando nuestro compromiso y respaldo a las propuestas de @ivancepedacastr y @aida_quilcue.

✨ El Cambio es con Vos.`
  return (
    <section className={style.Noticia}>
      <div className={style.Instagram}>
        <Suspense
          fallback={<div className="loading-placeholder">Loading...</div>}
        >
          <InstagramEmbed
            url="https://www.instagram.com/p/DZaeBz4kXFa/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA=="
            width={328}
          />
        </Suspense>
      </div>
      <div className={style.Separador}></div>
      <div className={style.NoticeBox}>
        <h1 className={style.Tittle}>En mayo le apostamos a los territorios y seguimos trabajando por Cali desde nuestra curul El Cambio es con Vos.</h1>
        <h5 className={style.Fecha}>Junio 10 del 2026</h5>
        <ExpandableText text={Notice1} limit={800} />
        <p className={style.reportero}>
          Oficina de Comunicaciones Concejal Rodrigo Salazar, Partido Alianza
          Verde 🌻{" "}
        </p>
      </div>
    </section>
  );
};

export default Semana57;
